module.exports = __webpack_public_path__ + "static/media/searchIcon.b714c473.svg";